/**
*
*/
import React, { Fragment, useState, useEffect, useRef } from 'react';
// import PropTypes from 'prop-types';
import Modal from 'react-modal';

//Apis 
import {
    communityValidEmail,
    communityValidateMobile,
    generateEmailOTP,
    generateMobileOTP,
    authSignIn
} from '../tm-apis';

//Helpers
import { setDefaultEnvObj, mobileCheck, gtmSend } from '@tickled-media/web-components.tm-helpers';

//Icons
import TapIcon from "./icons/TapIcon.js";
import CrossRegularSmdBlackIcon from "./icons/CrossRegularSmdBlackIcon";
import ConformationTickMarkIcon from "./icons/ConformationTickMarkIcon";
import ShowPasswordEyeIcon from "./icons/ShowPasswordEyeIcon";
import HidePasswordEyeIcon from "./icons/HidePasswordEyeIcon";
import InformationIcon from "./icons/InformationIcon";
import ErrorValidationIcon from "./icons/ErrorValidationIcon";

// Other Components
import ForgotPasswordOTPWidget from '../tm-forgot-password-otp-widget';
import VerifyOTPWidget from '../tm-verify-otp-widget';
import ConfirmWidget from '@tickled-media/web-components.tm-confirm-widget';
import ThreeBounceAnimationIcon from "@tickled-media/web-components.tm-three-bounce-loader";
import Notification from "@tickled-media/web-components.tm-notification";

//Style files
import cx from 'classnames/bind';
import './style.css'

import CryptoJS from "crypto-js"

const notificationConfig = {device: "desktop", type: "error", title: "Validation Error", duration: 6, placement: "topRight"};

const EmailLogin = (props) => {

    const { user, type, onEmailTemplateClose, emailWidgetShowAsModal, onLoginSuccess, customStyles, showConfirmWidget, translation } = props;

    const [isEmailVerify, setEmailVerify] = useState(false),
        [isPasswordShow, setPasswordShow] = useState(false),
        [isNotRegisterSectionShow, SetNotRegisterSectionShow] = useState(false),
        [isEmailInValid, setEmailInvalid] = useState(false),
        [showEmailRules, setEmailRules] = useState(false),
        [isEmailVerifictionInProgress, setEmailVerificationProgress] = useState(false),
        [isLoginBtnDisabled, setLoginBtnDisabled] = useState(true),
        [email, setEmail] = useState(''),
        [showVerifyOtpWidget, setVerifyOtpWidget] = useState(false),
        [showForgotPassword, setShowForgotPassword] = useState(false);

    useEffect(() => {
        document.addEventListener("touchstart", handleClickOutside);
        return () => {
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (email) {
            const emailTimeout = setTimeout(() => {
                validateEmailId(email);
            }, 500)

            return () => clearTimeout(emailTimeout);
        }
        if (email.length === 0) {
            setEmailInvalid(false)
        }
    }, [email])

    const validateEmailId = (text) => {
        if (/[a-zA-Z0-9.'\-#&%\/_]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9][a-zA-Z0-9\-_]{1,25}$/.test(text)) {
            setEmailRules(false);
            setVerifyOtpWidget(false);
            SetNotRegisterSectionShow(false);
            setEmailVerificationProgress(true);
            setEmailVerify(false);
            setEmailInvalid(false);
            communityValidEmail(setDefaultEnvObj(user), user, { email: text })
                .then((response) => {
                    if (response?.status === 200 && response?.data?.status_code === 200) {
                        setEmailVerificationProgress(false);
                        if (response?.data?.response?.email_count >= 1) {
                            gtmSend(`loginSignup`, `Login and Signup`, `Registered User by Email Address`, `--`, 0, { "action_detail": "Registered User by Email Address" })
                            setEmailVerify(true);
                        } else {
                            gtmSend(`loginSignup`, `Login and Signup`, `Non-Registered User by Email Address`, `--`, 0, { "action_detail": "Non-Registered User by Email Address" })
                            SetNotRegisterSectionShow(true);
                        }
                    } else {
                        Notification.send({
                            ...notificationConfig,
                            type: "info",
                            title: translation[`notification`],
                            message: response?.data?.message ? response.data.message : translation['somethingWentWrong']
                        });
                        setEmailVerificationProgress(false);
                        SetNotRegisterSectionShow(false);
                    }
                })
                .catch((error) => {
                    setEmailVerificationProgress(false);
                    console.warn("Error", error);
                })
        } else {
            SetNotRegisterSectionShow(false);
            setEmailInvalid(true);
        }
    }

    const onSendOTPClick = () => {
        const formData = new FormData();
        formData.append('identifier', email);
        formData.append('source', `sign-up`);
        formData.append('resend', 0);

        gtmSend(`loginSignup`, `Login and Signup`, `Send OTP by Email`, `--`, 0 , {"action_detail" : `Send OTP by Email`})
        props.loading(true);
        generateEmailOTP(setDefaultEnvObj(user), user, formData)
        .then((response) => {
            if(response?.status === 200 && response?.data?.status) {
                setVerifyOtpWidget(true);
            } else {
                Notification.send({
                    ...notificationConfig,
                    type: "info",
                    title: translation[`notification`],
                    message: response?.data?.message ? response.data.message : translation['somethingWentWrong']
                });
            }
            props.loading(false);
        })
        .catch((error) => {
            props.loading(false);
            console.warn("Error",error);
        })
    }

    const ref = useRef(null);
    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target) && mobileCheck()) {
            setEmailRules(false);
        }
    }

    const clearState = () => {
        setEmailVerify(false);
        SetNotRegisterSectionShow(false);
        setLoginBtnDisabled(true);
        setEmailInvalid(false);
        setEmailRules(false);
        setEmail(``);
    }

    const onPasswordInput = (password) => {
        if(/^.{6,}$/.test(password)) {
            setLoginBtnDisabled(false);
        }else {
            setLoginBtnDisabled(true);
        }
    }

    const onFormSubmit = (event) => {
        event.preventDefault();

        const form = event.target;

        const emailValue = form.elements[`email-check`].value,
            passwordValue = form.elements[`sign-in-password`].value,
            key = CryptoJS.enc.Utf8.parse(`tickled012345678`),
            iv  = CryptoJS.enc.Utf8.parse(''),
            encryptedCP = CryptoJS.AES.encrypt(passwordValue, key, { iv: iv }),
            password = encryptedCP.toString();

        const payload = {
            method: 'email',
            email: emailValue,
            password: password,
        }

        props.loading(true);
        authSignIn(setDefaultEnvObj(user), user, payload)
        .then((data) => {
            if (data && data.response && data.status === true) {
                // we don't need to update loading on a successful auth
                authenticateEmailUser(data.response)
            } else {
                props.loading(false);
                // handle unexpected login failed.
                gtmSend(`loginSignup`, `Login and Signup`, `Login Error`, `${translation['somethingWentWrong']}`, 0 , {"action_detail" : `Login Error`})
                Notification.send({
                    ...notificationConfig,
                    type: "info",
                    title: translation[`notification`],
                    message: translation['somethingWentWrong']
                });
            }
        })
        .catch((error) => {
            props.loading(false);
            console.warn("Error", error);
            if (error.response) {
                const response = error.response?.data;
                gtmSend(`loginSignup`, `Login and Signup`, `Login Error`, `${response.error?.message ? response.error.message : translation['somethingWentWrong']}`, 0 , {"action_detail" : `Login Error`})
                 // error invalid password || error user not registered
                const notificationMessage = response?.message ? response.message : translation['somethingWentWrong'];
                Notification.send({
                    ...notificationConfig,
                    type: "info",
                    title: translation[`notification`],
                    message: notificationMessage,
                });
            }
        })
    }

    const onForgotPasswordClose = (flag) => {
        setShowForgotPassword(flag)
    }

    const authenticateEmailUser = (data) => {
        gtmSend(
            `loginSignup_login_successful`,
            `Login and Signup`,
            `Login Successful via Email`,
            `--`,
            0,
            { action_detail: `Login Successful via Email` }
        );
        onLoginSuccess(data);
    };

    return (
        <Fragment>
            <div className={cx(`sign-in-form-section`)}>
                <form onSubmit={onFormSubmit}>
                    <div className={cx(`element-wrap`)}>
                        <div className={`email-wrap`}>
                            <input
                                className={`${isEmailInValid ? 'has-error' : ''}`}
                                type="text"
                                placeholder={translation[`emailInputPlaceholder`]}
                                onInput={(e) => { setEmail(e.target.value); }}
                                spellCheck="false"
                                id={`email-check`}
                                name={`email-check`}
                                value={email}
                                disabled={(isEmailVerifictionInProgress) ? "disabled" : ""}
                            />

                            {
                                isEmailVerifictionInProgress && <div className={cx("loader")}></div>
                            }
                        </div>
                        {
                            isEmailVerify && !isEmailInValid && email.length > 0 &&
                            <span>
                                <ConformationTickMarkIcon />
                            </span>
                        }

                        {
                            isEmailInValid &&
                            <div className={`invalid-text error-message-text email-error`}>
                                <span className={cx('icon')} onClick={() => setEmailRules(true)}><InformationIcon /></span>
                                <span>{translation[`invalidErrorMessageText`]}</span>
                            </div>
                        }

                        {
                            showEmailRules &&
                            <div className={cx(`invalid-email-wrapper`)} id={`invalid-email-wrapper`}>
                                <div className={cx(`invalid-email-wrap`)} id={`invalid-email-wrap`} ref={ref}>

                                    <div className={cx(`only-mobile icon-wrap`)}>
                                        <span className={cx(`icon`)}></span>
                                    </div>

                                    <div className={cx(`heading-text`)}>
                                        {translation[`emailAddressPrerequisitesText`]}
                                    </div>

                                    <div className={cx(`description-text`)}>
                                        {translation[`invalidEmailSectionHeaderDescriptionText`]}

                                        <ul>
                                            <li>{translation[`invalidEmailCharacterRule`]}</li>
                                            <li>{translation[`invalidEmailNumberRule`]}</li>
                                            <li>{translation[`invalidEmailSpecialCharacterRule`]}</li>
                                            <li>{translation[`invalidEmailSpecialSymbolRule`]}</li>
                                            <li>{translation[`invalidEmailDomainRule`]}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    {
                        isEmailVerify && !isEmailInValid &&
                        <Fragment>
                            <div className={cx(`element-wrap`)}>
                                <input
                                    type={`${isPasswordShow ? "text" : "password"}`}
                                    placeholder={translation[`pwdInputPlaceholder`]}
                                    onInput={(e) => { onPasswordInput(e.target.value) }}
                                    id={`sign-in-password`}
                                    name={`sign-in-password`}
                                    autoComplete="off"
                                />
                                {
                                    <span onClick={() => setPasswordShow(!isPasswordShow)}>
                                        {isPasswordShow ? <ShowPasswordEyeIcon /> : <HidePasswordEyeIcon />}
                                    </span>
                                }
                            </div>
                            <div className={cx(`element-wrap`)}>
                                <div className={`forgot-pwd-btn`} >
                                    <span onClick={() => { setShowForgotPassword(!showForgotPassword); gtmSend(`loginSignup`, `Login and Signup`, `Forgot Password via Email`, `--`, 0, { "action_detail": `Forgot Password via Email` }) }}>{translation[`forgotPwdText`]}</span>
                                </div>
                            </div>
                            <div className={cx(`element-wrap`)} placeholder={`Enter Pasasword`}>
                                <button type={`submit`} className={cx(`sign-in-btn ${isLoginBtnDisabled ? 'disabled' : 'enable'}`)} disabled={isLoginBtnDisabled ? true : false}>{translation[`signInText`]}</button>
                            </div>
                        </Fragment>
                    }
                </form>

                {
                    isNotRegisterSectionShow &&
                    <div className={cx(`email-not-register-wrapper`)}>
                        <div className={cx(`not-register-wrap`)}>
                            <div className={cx(`icon-wrap`)}>
                                <TapIcon />
                            </div>
                            <div className={cx(`text-wrap`)}>
                                <div className={cx(`not-found-text`)}>
                                    {translation[`emailNotRegisterText`]}
                                </div>
                                <div className={cx(`otp-verify-text`)}>
                                    {translation[`verifyOtpText`]}
                                </div>
                            </div>
                        </div>

                        <div className={cx(`send-otp-wrap`)}>
                            <button onClick={() => onSendOTPClick()}>{translation[`sendOtpBtnText`]}</button>
                        </div>
                    </div>
                }
            </div>
            {
                emailWidgetShowAsModal && showForgotPassword
                    ?
                    <Modal isOpen={emailWidgetShowAsModal}
                        onAfterOpen={() => console.log(`open`)}
                        onRequestClose={() => console.log(`close`)}
                        overlayClassName="forgot-password-container-myOverlayClass"
                        style={customStyles}
                    >
                        <ForgotPasswordOTPWidget
                            user={user}
                            email={email}
                            type={type}
                            translation={translation}
                            customStyles={customStyles}
                            onForgotPasswordClose={(flag) => onForgotPasswordClose(flag)}
                        />
                    </Modal>
                    :
                    <div className={cx(`forgot-password-otp-widget ${showForgotPassword ? 'show' : 'hide'}`)}>
                        <ForgotPasswordOTPWidget
                            user={user}
                            email={email}
                            type={type}
                            translation={translation}
                            customStyles={customStyles}
                            onForgotPasswordClose={(flag) => onForgotPasswordClose(flag)}
                        />
                    </div>
            }

            {
                emailWidgetShowAsModal && showVerifyOtpWidget
                    ?
                    <Modal isOpen={emailWidgetShowAsModal}
                        onAfterOpen={() => console.log(`open`)}
                        onRequestClose={() => console.log(`close`)}
                        overlayClassName="verify-otp-container-myOverlayClass"
                        style={customStyles}
                    >
                        <VerifyOTPWidget
                            onVerifyOTPClose={(flag) => setVerifyOtpWidget(flag)}
                            user={user}
                            emailWidgetShowAsModal={emailWidgetShowAsModal}
                            showVerifyOtpWidget={showVerifyOtpWidget}
                            email={email}
                            type={type}
                            translation={translation}
                            customStyles={customStyles}
                            onUserRegister={(data) => {
                                authenticateEmailUser(data);
                            }}
                        />
                    </Modal>
                    :
                    <div className={`verify-otp-widget ${showVerifyOtpWidget ? 'show' : 'hide'}`}>
                        <VerifyOTPWidget
                            onVerifyOTPClose={(flag) => setVerifyOtpWidget(flag)}
                            user={user}
                            email={email}
                            type={type}
                            translation={translation}
                            emailWidgetShowAsModal={emailWidgetShowAsModal}
                            showVerifyOtpWidget={showVerifyOtpWidget}
                            onUserRegister={(data) => authenticateEmailUser(data)}
                        />
                    </div>
            }
            {
                emailWidgetShowAsModal && showConfirmWidget
                    ?
                    <Modal isOpen={emailWidgetShowAsModal}
                        onAfterOpen={() => console.log(`open`)}
                        onRequestClose={() => console.log(`close`)}
                        overlayClassName="confirm-container-myOverlayClass"
                        style={customStyles}
                    >
                        <ConfirmWidget
                            onConfirmWidgetClose={(flag) => { props.setShowConfirmWidget(flag) }}
                            closePreviousWidget={(flag) => { onEmailTemplateClose(flag); clearState(); }}
                            goBackToWidget={true}
                            translation={translation}
                            screen={`${isEmailVerify ? 'Detail Screen' : 'Login Screen' }`}
                            confirmMessage={translation['confirmMessageEmail']}
                        />
                    </Modal>
                    :
                    <div className={`confirm-widget ${showConfirmWidget ? 'show' : 'hide'}`}>
                        <ConfirmWidget
                            onConfirmWidgetClose={(flag) => { props.setShowConfirmWidget(flag) }}
                            closePreviousWidget={(flag) => { onEmailTemplateClose(flag); clearState(); }}
                            goBackToWidget={true}
                            translation={translation}
                            screen={`${isEmailVerify ? 'Detail Screen' : 'Login Screen' }`}
                            confirmMessage={translation['confirmMessageEmail']}
                        />
                    </div>
            }
        </Fragment>
    )
}

const MobileLogin = (props) => {

    const { user, country, emailWidgetShowAsModal, type, customStyles, onLoginSuccess, onEmailTemplateClose, showConfirmWidget, translation, enabledCountries } = props;

    //Country Code selection data for dropdown
    const countrySelection = {
        'sg' : {
            'country': 'Singapore',
            'countryCode': '+65',
            'country_iso_code' : 'sg',
            'isEnabled': enabledCountries && enabledCountries.includes('sg'),
            'maxLimit': 8,
            'minLimit': 8
        },
        'th' : {
            'country': 'Thailand',
            'countryCode': '+66',
            'country_iso_code' : 'th',
            'isEnabled': enabledCountries && enabledCountries.includes('th'),
            'maxLimit': 10,
            'minLimit': 9
        },
        'my' : {
            'country': 'Malaysia',
            'countryCode': '+60',
            'country_iso_code' : 'my',
            'isEnabled': enabledCountries && enabledCountries.includes('my'),
            'maxLimit': 8,
            'minLimit': 7
        },
        'id' : {
            'country': 'Indonesia',
            'countryCode': '+62',
            'country_iso_code' : 'id',
            'isEnabled': enabledCountries && enabledCountries.includes('id'),
            'maxLimit': 11,
            'minLimit': 8
        },
        'ph' : {
            'country': 'Philippines',
            'countryCode': '+63',
            'country_iso_code' : 'ph',
            'isEnabled': enabledCountries && enabledCountries.includes('ph'),
            'maxLimit': 11,
            'minLimit': 10
        },
        'vn' : {
            'country': 'Vietnam',
            'countryCode': '+84',
            'country_iso_code' : 'vn',
            'isEnabled': enabledCountries && enabledCountries.includes('vn'),
            'maxLimit': 11,
            'minLimit': 10
        },
        'in' : {
            'country': 'India',
            'countryCode': '+91',
            'country_iso_code' : 'in',
            'isEnabled': enabledCountries && enabledCountries.includes('in'),
            'maxLimit': 11,
            'minLimit': 10
        },
    }

    const [mobileNumber, setMobileNumber] = useState(''),
        [countryCode, setCountryCode] = useState(countrySelection[country]? countrySelection[country].countryCode : ''),
        [isoCode, setIsoCode] = useState(countrySelection[country]? countrySelection[country].country_iso_code : ''),
        [maxLimit, setMaxLimit] = useState(countrySelection[country]? countrySelection[country].maxLimit : 11),
        [minLimit, setMinLimit] = useState(countrySelection[country]? countrySelection[country].minLimit : 7),
        [openDropdown, setOpenDropdown] = useState(false),
        [dropdownEnabled, setDropdownEnabled] = useState(true),
        [isContinueDisabled, setContinueDisabled] = useState(true),
        [mobileVerified, setMobileVerified] = useState(false),
        [isNotRegisterSectionShow, setNotRegisterSectionShow] = useState(false),
        [showVerifyOtpWidget, setVerifyOtpWidget] = useState(false),
        [isLoginBtnDisabled, setLoginBtnDisabled] = useState(true),
        [isPasswordShow, setPasswordShow] = useState(false),
        [invalidNumber, setInvalidNumber] = useState(false),
        [showForgotPassword, setShowForgotPassword] = useState(false);

    useEffect(() => {
        if(countrySelection && Object.keys(countrySelection).length > 0){
            let count = 0;
            Object.keys(countrySelection).forEach((key)=>{
                if(countrySelection[key].isEnabled) count++
            })
            if(count <= 1) setDropdownEnabled(false)
        }
        if (mobileCheck()) {
            document.addEventListener("touchstart", handleClickOutside);
            return () => {
                document.removeEventListener("touchstart", handleClickOutside);
            }
        } else {
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, []);

    useEffect(() => {
        const element = document.getElementById('mobile-check');
        if(element && element.value && element.value.length >= minLimit){
            setContinueDisabled(false)
        }else{
            setContinueDisabled(true)
        }
        setMobileVerified(false);
        setNotRegisterSectionShow(false);
        setLoginBtnDisabled(true);
        setInvalidNumber(false);
    },[minLimit, mobileNumber])

    useEffect(() => {
        if (mobileNumber && minLimit) {
            const mobileTimeOut = setTimeout(() => {
                if (mobileNumber.length < minLimit) {
                    setInvalidNumber(true)
                }
            }, 2000)

            return () => clearTimeout(mobileTimeOut);
        }
    }, [mobileNumber])

    const digitValidate = (element) => {
        element.target.value = element.target.value.replace(/[^0-9]/g,'');
        setMobileNumber(element.target.value);
    }

    const wrapperRef = useRef();

    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setOpenDropdown(false)
        }
    }

    const selectCountry = (data) => {
        setCountryCode(data.countryCode);
        setMinLimit(data.minLimit);
        setMaxLimit(data.maxLength);
        setIsoCode(data.country_iso_code);
        setOpenDropdown(false);
    }

    const validateMobile = (e) => {
        e.preventDefault();
        if(!isContinueDisabled){
            props.loading(true);
            communityValidateMobile(setDefaultEnvObj(user), user, { country_iso_code: isoCode, phone: mobileNumber, source: "sign-up" })
                .then((response) => {
                    if (response && response.status === 200 && response.data && response.data.status_code && response.data.status_code === 200) {
                        if (response.data.response && response.data.response.is_verified === 1) {
                            gtmSend(`loginSignup`, `Login and Signup`, `Registered User by Mobile Number`, `--`, 0, { "action_detail": "Registered User by Mobile Number" })
                            setMobileVerified(true);
                        } else {
                            gtmSend(`loginSignup`, `Login and Signup`, `Non-Registered User by Mobile Number`, `--`, 0, { "action_detail": "Non-Registered User by Mobile Number" })
                            setNotRegisterSectionShow(true);
                        }
                    } else {
                        Notification.send({
                            ...notificationConfig,
                            type: "info",
                            title: translation[`notification`],
                            message: response?.data?.message ? response.data.message : translation['somethingWentWrong']
                        });
                        // setNotRegisterSectionShow(false);
                    }
                    props.loading(false);
                })
                .catch((error) => {
                    props.loading(false);
                    console.warn("Error", error);
                })
        }
    }

    const onSendOTPClick = () => {
        const formData = new FormData();
        formData.append('identifier', mobileNumber);
        formData.append('source', `sign-up`);
        formData.append('country_iso_code', isoCode);

        gtmSend(`loginSignup`, `Login and Signup`, `Send OTP by Mobile Number`, `--`, 0 , {"action_detail" : `Send OTP by Mobile Number`})
        props.loading(true);
        generateMobileOTP(setDefaultEnvObj(user), user, formData)
        .then((response) => {
            if(response?.status === 200 && response?.data?.status) {
                setVerifyOtpWidget(true);
            } else {
                Notification.send({
                    ...notificationConfig,
                    type: "info",
                    title: translation[`notification`],
                    message: response?.data?.message ? response.data.message : translation['somethingWentWrong']
                });
            }
            props.loading(false);
        })
        .catch((error) => {
            props.loading(false);
            console.warn("Error",error);
        })
    }

    const onPasswordInput = (password) => {
        if(/^.{6,}$/.test(password)) {
            setLoginBtnDisabled(false);
        }else {
            setLoginBtnDisabled(true);
        }
    }

    const onFormSubmit = (event) => {
        event.preventDefault();

        const form = event.target;

        const mobileValue = form.elements[`mobile-check`].value,
            passwordValue = form.elements[`sign-in-password`].value,
            key = CryptoJS.enc.Utf8.parse(`tickled012345678`),
            iv  = CryptoJS.enc.Utf8.parse(''),
            encryptedCP = CryptoJS.AES.encrypt(passwordValue, key, { iv: iv }),
            password = encryptedCP.toString();

        const payload = {
            method: 'phone',
            phone: String(countryCode).replace('+','') + mobileValue,
            password: password,
        }

        props.loading(true);
        authSignIn(setDefaultEnvObj(user), user, payload)
        .then((data) => {
            if (data && data.response && data.status === true) {
                authenticateMobileUser(data.response);
            } else {
                props.loading(false);
                gtmSend(`loginSignup`, `Login and Signup`, `Login Error`, `${translation['somethingWentWrong']}`, 0 , {"action_detail" : `Login Error`})
                Notification.send({
                    ...notificationConfig,
                    type: "info",
                    title: translation[`notification`],
                    message: translation['somethingWentWrong']
                });
            }
        })
        .catch((error) => {
            props.loading(false);
            console.warn("Error", error);
            if (error.response) {
                const response = error.response?.data;
                gtmSend(`loginSignup`, `Login and Signup`, `Login Error`, `${response.error?.message ? response.error.message : translation['somethingWentWrong']}`, 0 , {"action_detail" : `Login Error`})
                const notificationMessage = response?.message ? response.message : translation['somethingWentWrong'];
                Notification.send({
                    ...notificationConfig,
                    type: "info",
                    title: translation[`notification`],
                    message: notificationMessage,
                });
            }
        })
    }
    
    const authenticateMobileUser = (data) => {
        gtmSend(
            `loginSignup_login_successful`,
            `Login and Signup`,
            `Login Successful via Mobile`,
            `--`,
            0,
            { action_detail: `Login Successful via Mobile` }
        );
        if (onLoginSuccess) onLoginSuccess(data);
    }

    const clearState = () => {
        setCountryCode(countrySelection[country]? countrySelection[country].countryCode : '');
        setIsoCode(countrySelection[country]? countrySelection[country].country_iso_code : '');
        setMaxLimit(countrySelection[country]? countrySelection[country].maxLimit : 11);
        setMinLimit(countrySelection[country]? countrySelection[country].minLimit : 7);
        setMobileNumber('');
        setOpenDropdown(false);
        setDropdownEnabled(true);
        setMobileVerified(false);
        setNotRegisterSectionShow(false);
        setLoginBtnDisabled(true);
        setPasswordShow(false)
    }

    const onForgotPasswordClose = (flag) => {
        setShowForgotPassword(flag)
    }

    return (
        <Fragment>
            <div className={cx(`sign-in-form-section`)}>
                <form onSubmit={onFormSubmit}>
                    <div className={cx(`wrapper`)} ref={wrapperRef}>
                        <div className={`mobile-wrap ${invalidNumber ? 'has-error' : ''}`}>
                            <div className={cx('select-country')} onClick={() => setOpenDropdown(!openDropdown)}>
                                <span className={cx(`flag-icons-sprite flag-${isoCode}`)}></span>
                                <span className={cx(`country-code`)}>{countryCode}</span>
                            </div>
                            <input
                                type={`tel`}
                                placeholder={translation['enterMobileNumber']}
                                onInput={(e) => digitValidate(e)}
                                maxLength={maxLimit}
                                spellCheck="false"
                                id={`mobile-check`}
                                name={`mobile-check`}
                                value={mobileNumber}
                            />
                        </div>
                        {
                            openDropdown && dropdownEnabled &&
                            <ul className={cx('country-dropdown')}>
                                {
                                    Object.values(countrySelection).map((data, index)=>{
                                        if(data && data.isEnabled){
                                            return (
                                                <li key={index} onClick={()=>selectCountry(data)}>
                                                    <span className={cx(`flag-icons-sprite flag-${data.country_iso_code}`)}></span>
                                                    <span className={cx('country-code')}>{data.countryCode}</span>
                                                    {data.country}
                                                </li>
                                            )
                                        }
                                    })
                                }
                            </ul>
                        }
                        {
                            mobileVerified && !invalidNumber && mobileNumber.length > 0 &&
                            <span className={cx('confirmation-icon')}>
                                <ConformationTickMarkIcon />
                            </span>
                        }
                        {
                            invalidNumber &&
                            <div className={`invalid-text error-message-text mobile-error`}>
                                <span className={cx('icon')}><ErrorValidationIcon/></span>
                                <span>{translation['invalidMobileNumberText']}</span>
                            </div>
                        }
                    </div>
                    {
                        !isNotRegisterSectionShow && !mobileVerified && !invalidNumber &&
                        <div className={cx(`element-wrap`)}>
                            <button className={cx(`sign-in-btn ${isContinueDisabled? 'disabled' : 'enable'} `)} disabled={isContinueDisabled? true : false} onClick={(e)=>validateMobile(e)}>{translation['continue']}</button>
                        </div>
                    }
                    {
                        mobileVerified &&
                        <Fragment>
                            <div className={cx(`element-wrap`)}>
                                <input
                                    type={`${isPasswordShow ? "text" : "password"}`}
                                    placeholder={translation[`pwdInputPlaceholder`]}
                                    onInput={(e) => { onPasswordInput(e.target.value) }}
                                    id={`sign-in-password`}
                                    name={`sign-in-password`}
                                    autoComplete="off"
                                />
                                {
                                    <span onClick={() => setPasswordShow(!isPasswordShow)}>
                                        {isPasswordShow ? <ShowPasswordEyeIcon /> : <HidePasswordEyeIcon />}
                                    </span>
                                }
                            </div>
                            <div className={cx(`element-wrap`)}>
                                <div className={`forgot-pwd-btn`} >
                                    <span onClick={() => { setShowForgotPassword(!showForgotPassword); gtmSend(`loginSignup`, `Login and Signup`, `Forgot Password via Mobile`, `--`, 0, { "action_detail": `Forgot Password via Mobile` }) }}>{translation[`forgotPwdText`]}</span>
                                </div>
                            </div>
                            <div className={cx(`element-wrap`)} placeholder={`Enter Pasasword`}>
                                <button type={`submit`} className={cx(`sign-in-btn ${isLoginBtnDisabled ? 'disabled' : 'enable'}`)} disabled={isLoginBtnDisabled ? true : false}>{translation[`signInText`]}</button>
                            </div>
                        </Fragment>
                    }
                </form>
                {
                    isNotRegisterSectionShow &&
                    <div className={cx(`email-not-register-wrapper`)}>
                        <div className={cx(`not-register-wrap`)}>
                            <div className={cx(`icon-wrap`)}>
                                <TapIcon />
                            </div>
                            <div className={cx(`text-wrap`)}>
                                <div className={cx(`not-found-text`)}>
                                    {translation['mobileNotRegistered']}
                                </div>
                                <div className={cx(`otp-verify-text`)}>
                                    {translation['verifyMobileNumber']}
                                </div>
                            </div>
                        </div>

                        <div className={cx(`send-otp-wrap`)}>
                            <button onClick={() => onSendOTPClick()}>{translation[`sendOtpBtnText`]}</button>
                        </div>
                    </div>
                }
            </div>
            {
                emailWidgetShowAsModal && showForgotPassword
                    ?
                    <Modal isOpen={emailWidgetShowAsModal}
                        onAfterOpen={() => console.log(`open`)}
                        onRequestClose={() => console.log(`close`)}
                        overlayClassName="forgot-password-container-myOverlayClass"
                        style={customStyles}
                    >
                        <ForgotPasswordOTPWidget
                            user={user}
                            mobileNumber={mobileNumber}
                            type={type}
                            translation={translation}
                            isoCode={isoCode}
                            countryCode={countryCode}
                            customStyles={customStyles}
                            onForgotPasswordClose={(flag) => onForgotPasswordClose(flag)}
                        />
                    </Modal>
                    :
                    <div className={cx(`forgot-password-otp-widget ${showForgotPassword ? 'show' : 'hide'}`)}>
                        <ForgotPasswordOTPWidget
                            user={user}
                            mobileNumber={mobileNumber}
                            type={type}
                            translation={translation}
                            isoCode={isoCode}
                            countryCode={countryCode}
                            customStyles={customStyles}
                            onForgotPasswordClose={(flag) => onForgotPasswordClose(flag)}
                        />
                    </div>
            }

            {
                emailWidgetShowAsModal && showVerifyOtpWidget
                    ?
                    <Modal isOpen={emailWidgetShowAsModal}
                        onAfterOpen={() => console.log(`open`)}
                        onRequestClose={() => console.log(`close`)}
                        overlayClassName="verify-otp-container-myOverlayClass"
                        style={customStyles}
                    >
                        <VerifyOTPWidget
                            onVerifyOTPClose={(flag) => setVerifyOtpWidget(flag)}
                            user={user}
                            emailWidgetShowAsModal={emailWidgetShowAsModal}
                            showVerifyOtpWidget={showVerifyOtpWidget}
                            mobileNumber={mobileNumber}
                            type={type}
                            isoCode={isoCode}
                            translation={translation}
                            countryCode={countryCode}
                            customStyles={customStyles}
                            onUserRegister={(data) => { authenticateMobileUser(data) }}
                        />
                    </Modal>
                    :
                    <div className={`verify-otp-widget ${showVerifyOtpWidget ? 'show' : 'hide'}`}>
                        <VerifyOTPWidget
                            onVerifyOTPClose={(flag) => setVerifyOtpWidget(flag)}
                            user={user}
                            mobileNumber={mobileNumber}
                            type={type}
                            isoCode={isoCode}
                            translation={translation}
                            countryCode={countryCode}
                            emailWidgetShowAsModal={emailWidgetShowAsModal}
                            showVerifyOtpWidget={showVerifyOtpWidget}
                            onUserRegister={(data) => { authenticateMobileUser(data) }}
                        />
                    </div>
            }

            {
                emailWidgetShowAsModal && showConfirmWidget
                    ?
                    <Modal isOpen={emailWidgetShowAsModal}
                        onAfterOpen={() => console.log(`open`)}
                        onRequestClose={() => console.log(`close`)}
                        overlayClassName="confirm-container-myOverlayClass"
                        style={customStyles}
                    >
                        <ConfirmWidget
                            onConfirmWidgetClose={(flag) => { props.setShowConfirmWidget(flag) }}
                            closePreviousWidget={(flag) => { onEmailTemplateClose(flag); clearState(); }}
                            goBackToWidget={true}
                            translation={translation}
                            screen={`${mobileVerified ? 'Detail Screen' : 'Login Screen' }`}
                            confirmMessage={translation['confirmMessageEmail']}
                        />
                    </Modal>
                    :
                    <div className={`confirm-widget ${showConfirmWidget ? 'show' : 'hide'}`}>
                        <ConfirmWidget
                            onConfirmWidgetClose={(flag) => { props.setShowConfirmWidget(flag) }}
                            closePreviousWidget={(flag) => { onEmailTemplateClose(flag); clearState(); }}
                            goBackToWidget={true}
                            translation={translation}
                            screen={`${mobileVerified ? 'Detail Screen' : 'Login Screen' }`}
                            confirmMessage={translation['confirmMessageEmail']}
                        />
                    </div>
            }
        </Fragment>
    )
}

const TabSwitcher = (props) => {
    const { translation } = props;
    return (
        <div className={cx('switch-wrap')}>
            <div className={cx('tab-switcher')}>
                <div className={cx(`wrapper ${props.type === 'email' ? 'selected' : ''}`)} onClick={() => { props.handleLoginType('email') }}>
                    {translation['emailAddress']}
                </div>
                <div className={cx(`wrapper ${props.type === 'mobile' ? 'selected' : ''}`)} onClick={() => { props.handleLoginType('mobile') }}>
                    {translation['mobileNumber']}
                </div>
            </div>
        </div>
    )
}

const EmailLoginOTPWidget = (props) => {
    const {
        user,
        onEmailTemplateClose,
        emailWidgetShowAsModal,
        onLoginSuccess,
        customStyles,
        translation,
        type,
        handleLoginType,
        showTabSwitcher,
        enabledCountries
    } = props;

    const [isLoading, setLoading] = useState(false),
        [showConfirmWidget, setShowConfirmWidget] = useState(false);

    const onClose = () => {
        setShowConfirmWidget(true);
    }

    const loading = (flag) => {
        setLoading(flag);
    }

    return (
        <div className={cx('emailLoginOTPWidget-view')}>
        { isLoading && <ThreeBounceAnimationIcon /> }
            <div className={cx(`email-login-close-icon`)} onClick={onClose}>
                <CrossRegularSmdBlackIcon />
            </div>

            <div className={cx(`icon-section`)}>
                <TapIcon />
                <h1>{translation[`tapHeading`]}</h1>
            </div>

            {
                showTabSwitcher &&
                <TabSwitcher type={type} handleLoginType={handleLoginType} translation={translation}/>
            }

            {
                type === 'mobile' ?
                    <MobileLogin
                        user={user}
                        type={type}
                        country={user.country}
                        translation={translation}
                        onEmailTemplateClose={onEmailTemplateClose}
                        emailWidgetShowAsModal={emailWidgetShowAsModal}
                        onLoginSuccess={onLoginSuccess}
                        customStyles={customStyles}
                        enabledCountries={enabledCountries}
                        showConfirmWidget={showConfirmWidget}
                        setShowConfirmWidget={setShowConfirmWidget}
                        loading={loading}
                    />
                    :
                    <EmailLogin
                        user={user}
                        type={type}
                        translation={translation}
                        onEmailTemplateClose={onEmailTemplateClose}
                        emailWidgetShowAsModal={emailWidgetShowAsModal}
                        onLoginSuccess={onLoginSuccess}
                        customStyles={customStyles}
                        showConfirmWidget={showConfirmWidget}
                        setShowConfirmWidget={setShowConfirmWidget}
                        loading={loading}
                    />
            }
        </div>
    )
}

export default EmailLoginOTPWidget;